import axios from "axios";

const address = process.env.NEXT_PUBLIC_API_URL;

export const createTextToImg = (token, params) => {
	let headers = { "Content-Type": "application/json" };

	if (token) {
		headers = { "Content-Type": "application/json", Authorization: `Bearer ${token}` };
	}

	let formData = new FormData();

	if (params.image) {
		formData.append("image", params.image);
		return axios.post(`${address}/v1/mljobs/`, formData, { headers: headers });
	} else {
		return axios.post(`${address}/v1/mljobs/`, JSON.stringify(params), { headers: headers });
	}
};

export const uploadStyleTransfer = (token, image) => {
	let headers = { "Content-Type": "application/json" };

	if (token) {
		headers = { "Content-Type": "application/json", Authorization: `Bearer ${token}` };
	}

	let formData = new FormData();
	formData.append("image", image);
	return axios.post(`${address}/v1/text2image/jobs/`, formData, { headers: headers });
};

export const addStyleToImage = (token, params, id) => {
	let headers = { "Content-Type": "application/json" };

	if (token) {
		headers = { "Content-Type": "application/json", Authorization: `Bearer ${token}` };
	}
	let formData = new FormData();

	formData.append("style_id", JSON.stringify(params.style_id));

	return axios.post(`${address}/v1/text2image/tasks/${id}/process/`, JSON.stringify(params), {
		headers: headers,
	});
};

export const saveTextToImageToUserBg = (token, id) => {
	return axios.post(
		`${address}/v1/mltasks/${id}/bg/`, {}, { headers: { Authorization: `Bearer ${token}` }, }
	);
};

export const saveTextToImageToGallery = ({ token, id }) => {
	return axios.post(
		`${address}/v1/mltasks/${id}/save/  `,
		{},
		{
			headers: { Authorization: `Bearer ${token}` },
		}
	);
};

export const getTextToImgTaskStatus = (task_id) => {
	return axios.get(`${address}/v1/mljobs/${task_id}/`);
};

export const getStyleTransferStatus = (job_id) => {
	return axios.get(`${address}/v1/text2image/jobs/${job_id}/ `);
};

export const getTextToImageStyles = (styleCategory = "") => {
	if (styleCategory) {
		return axios.get(`${address}/v1/imagegen/styles/?group=${styleCategory}`);
	}
	return axios.get(`${address}/v1/imagegen/styles/`);
};

export const getStartTextToImg = (favsIds) => {
	return axios.get(`${address}/v1/imagegen/tasks/?ids=${favsIds.join()}`);
};

export const getAIModels = () => {
	return axios.get(`${address}/v1/imagegen/models/ `);
};

export const getSamplers = () => {
	return axios.get(`${address}/v1/imagegen/samplers/ `);
};
